module.exports = __webpack_public_path__ + "static/dashboard-451f5fae4aee89f4920678a3ab356e4a.jpg";